import styled from "styled-components";

export const ImageView = styled.div`
  display: flex;
  flex-direction: column;

  & > button.thumbnail {
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
    width: 100%;
    min-height: 56px;
    max-height: 280px;
    margin-bottom: ${({ theme }) => theme.spacing.xxx_small }px;
    border-radius: ${({ theme }) => theme.border_radius.small }px;
    cursor: pointer;
    background-color: ${({ theme }) => theme.glass.background };
    border: 1px solid ${({ theme }) => theme.glass.border };
    backdrop-filter: ${({ theme }) => theme.glass.blur };
    box-shadow: inset 0 0 8px ${({ theme }) => theme.colors.text.default }22;
    position: relative;
    padding: 0;
    color: inherit;
  }

  & > button.thumbnail > img {
    width: 100%;
  }

  & > button.thumbnail > div.info {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: ${({ theme }) => theme.spacing.xx_small }px;
    position: absolute;
    inset: 0;
    top: auto;
    padding: ${({ theme }) => theme.spacing.xx_small }px;
    background: linear-gradient( ${({ theme }) => theme.colors.black.default }01, ${({ theme }) => theme.colors.black.default }DD );
    color: ${({ theme }) => theme.colors.white.default };

    min-height: ${({ theme }) => theme.font_size.xx_small }px;
    font-size: ${({ theme }) => theme.font_size.xx_small }px;
    line-height: ${({ theme }) => theme.font_size.xx_small }px;
  }
`;
